<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-application">
  <div class="p-30" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Appel et dépôt des candidatures</p>
        <p class="no-margin dark-gray text-sm">Modalités et dates limites de dépôt</p>

      </div>
    </div>
  </div>

  <div class="p-30">
    <div class="flex flex-column gap-30">
      <div style="border: solid 1px #F0F5FF; padding: 20px 30px 20px 30px;" class="bg-light-gray">
        <label class="flex gap-10 pointer" for="mail">
          <input type="checkbox" name="mail" id="mail" [(ngModel)]="application.mailOption"
            (ngModelChange)="onApplicationChange()">
          <img src="assets/sheet-icon.svg" alt="">
          <p class="dark-blue no-margin">Courrier recommandé</p>
        </label>

        <div *ngIf="application.mailOption" style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;"
          class="mt-20">
          <div style="grid-column: 1 / -1;">
            <p class="dark-blue no-margin">Adresse <span class="red">*</span></p>
            <input type="text" name="address" id="address" class="w-full text-md dark-blue pap-input"
              [(ngModel)]="application.address" (ngModelChange)="onApplicationChange()">
          </div>

          <div>
            <p class="dark-blue no-margin">Code Postal <span class="red">*</span></p>
            <input type="text" name="postal_code" id="zip" class="w-full text-md dark-blue pap-input"
              [(ngModel)]="application.zip" (ngModelChange)="onApplicationChange()">
          </div>

          <div>
            <p class="dark-blue no-margin">Ville / Commune <span class="red">*</span></p>
            <input type="text" name="city" id="city" class="w-full text-md dark-blue pap-input"
              [(ngModel)]="application.city" (ngModelChange)="onApplicationChange()">
          </div>
        </div>
      </div>

      <div style="border: solid 1px #F0F5FF; padding: 20px 30px 20px 30px;" class="bg-light-gray">
        <label class="flex gap-10 pointer" for="Email">
          <input type="checkbox" name="Email" id="Email" [(ngModel)]="application.emailOption"
            (ngModelChange)="onApplicationChange()">
          <img src="assets/mail-icon.svg" alt="">
          <p class="dark-blue no-margin">Email</p>
        </label>
        <div class="mt-20" *ngIf="application.emailOption">
          <p class="dark-blue no-margin">Adresse email de réception <span class="red">*</span></p>
          <input type="text" name="postal_code" id="zip" class="w-full text-md dark-blue pap-input"
            [(ngModel)]="application.emailAddress" (ngModelChange)="onApplicationChange()">
        </div>
      </div>

      <div style="border: solid 1px #F0F5FF; padding: 20px 30px 20px 30px;" class="bg-light-gray">
        <label class="flex gap-10 pointer" for="hand">
          <input type="checkbox" name="hand" id="hand" [(ngModel)]="application.handOption"
            (ngModelChange)="onApplicationChange()">
          <img src="assets/hand-icon.svg" alt="">
          <p class="dark-blue no-margin">Remise en main propre contre décharge</p>
        </label>

        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" class="mt-20"
          *ngIf="application.handOption">
          <div>
            <p class="dark-blue no-margin">Nom de la personne <span class="red">*</span></p>
            <input type="text" name="postal_code" id="zip" class="w-full text-md dark-blue pap-input"
              [(ngModel)]="application.lastName" (ngModelChange)="onApplicationChange()">
          </div>

          <div>
            <p class="dark-blue no-margin">Prénom de la personne <span class="red">*</span></p>
            <input type="text" name="city" id="city" class="w-full text-md dark-blue pap-input"
              [(ngModel)]="application.firstName" (ngModelChange)="onApplicationChange()">
          </div>
        </div>
      </div>
    </div>

    <div style="padding-top: 20px; border-top: solid 1px #F0F5FF;" class="mt-20"></div>

    <h3 class="dark-blue bold text-md no-margin mb-20">Dates limites de dépôt</h3>
    <div class="flex gap-10 align-items-center mb-10">
      <img src="assets/calendar-blue-icon.svg" alt="">
      <h3 class="dark-blue bold text-md no-margin">Premier tour</h3>
    </div>
    <p class="dark-blue no-margin">Date limite <span class="red">*</span></p>

    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;" class="mb-30">
      <div>
        <input type="date" name="first_open" id="first_open" class="text-md dark-blue pap-input w-full"
          [(ngModel)]="firstRoundLimitString" [min]="minDate" [max]="maxDate" (ngModelChange)="onApplicationChange()">
      </div>
      <div>
        <input type="time" name="first_open_time" id="first_open_time" class="text-md dark-blue title-input pap-input"
          style="width: 40%;" [(ngModel)]="firstRoundLimitTime" (ngModelChange)="onApplicationChange()">
      </div>
    </div>
    <div class="flex gap-10 align-items-center mb-10">
      <img src="assets/calendar-blue-icon.svg" alt="">
      <h3 class="dark-blue bold text-md no-margin">Second tour</h3>
    </div>
    <p class="dark-blue no-margin">Date limite <span class="red">*</span></p>
    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;" class="mb-30">
      <div>
        <input type="date" name="first_close" id="first_close" class="text-md dark-blue pap-input w-full"
          [(ngModel)]="secondRoundLimitString" (ngModelChange)="onApplicationChange()" [min]="minDate"
          [max]="secondRoundMaxDate">
      </div>
      <div>
        <input type="time" name="first_close_time" id="first_close_time" class="text-md dark-blue title-input pap-input"
          style="width: 40%;" [(ngModel)]="secondRoundLimitTime" (ngModelChange)="onApplicationChange()">
      </div>
    </div>

  </div>
</div>